import { createContext, JSX, useState } from "react";

interface ReportsTileCollapseProps {
  collapseAll: () => void;
  collapseTile: (tileId: number) => void;
  expandedTiles: number[];
  expandAll: (tiles: number[]) => void;
  expandTile: (tileId: number) => void;
}

export const ReportsTileCollapseContext = createContext<Partial<ReportsTileCollapseProps>>({});

export const ReportsTileCollapseProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [expandedTiles, setExpandedTiles] = useState<number[]>([]);

  const collapseAll = () => {
    setExpandedTiles([]);
  }

  const collapseTile = (tileId: number) => {
    const index = expandedTiles.findIndex((ti) => ti === tileId);
    const newTiles = [...expandedTiles]
    newTiles.splice(index, 1)
    setExpandedTiles(newTiles);
  }

  const expandAll = (tiles: number[]) => {
    setExpandedTiles(tiles);
  }

  const expandTile = (tileId: number) => {
    if (!expandedTiles.includes(tileId)) {
      setExpandedTiles(expandedTiles.concat(tileId));
    }
  }

  return (
    <ReportsTileCollapseContext.Provider
      value={{
        collapseAll,
        collapseTile,
        expandAll,
        expandTile,
        expandedTiles,
      }}
    >
      {children}
    </ReportsTileCollapseContext.Provider>
  );
};
